import React, { useState } from 'react'
import { Container, FormField, Header, Input, Link, Popover, Select, SpaceBetween, StatusIndicator, Tiles } from "@amzn/awsui-components-react-v3";
import { Controller } from "react-hook-form";
import { DropdownStatusProps } from '@amzn/awsui-components-react-v3/polaris/internal/components/dropdown-status';
import { scan_alias_api } from "../../utils/constants";

export default function OwnershipInfo(props: any) {
  const [options, setOptions] = useState<any[]>([]);
  const [status, setStatus] = useState<DropdownStatusProps.StatusType | undefined>('pending')
  let filteringText = '';

  // helper function to convert the response from backend to a format which the
  // select input field could display
  const format_option = (alias_list: string[]) => {
    let new_list: any = [];
    for (const element of alias_list) {
      let obj: any = {}
      obj['value'] = element;
      new_list.push(obj);
    }
    return new_list
  }
  // this function fetches data from the alias csv file
  async function getEmpData(ft: string) {
    if (ft.length < 3)
      return;
    let request: any;
    request = {};
    request["action"] = "get_alias_list";
    request["filter_text"] = filteringText;

    try {
      const response = await fetch(scan_alias_api, {
        mode: 'cors',
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
          'Accept': 'application/json',
          'Authorization': props.jwt,
        },
        body: JSON.stringify(request)
      });
      if (ft !== filteringText) {
        // there is another request in progress, discard the result of this one
        return;
      }
      response.json().then(Data => {
        console.log(Data.alias_list);
        let opts = format_option(Data.alias_list);
        console.log(opts)
        setOptions(opts)
      }).then(() => setStatus('finished'))
    }
    // TODO: Handle the error more gracefully by adding a pop up
    catch (err) {
      setStatus('error')
      console.log(err);
    }
  }

  function handleLoadItems(detail: any) {
    filteringText = detail.filteringText;
    setOptions([]);
    setStatus('loading');
    getEmpData(filteringText);
  }


  return (
    <Container
      header={
        <Header
          variant="h2"
          description="Ownership info about the 3P SaaS/PaaS"
        >
          Ownership information
        </Header>
      }
    >
      <SpaceBetween size="l">
        <SpaceBetween size="s" direction="horizontal">
          <FormField
            description="This person would be assigned as the primary owner of the 3P product registered"
            label="Primary owner's alias" errorText={props.errors?.primary_owner_alias?.message?.toString()}>
            <Controller
              name="primary_owner_alias"
              rules={{
                required: "Required field",
              }}
              control={props.control}
              defaultValue=""
              render={({ field: { onChange, value, onBlur } }) => (
                <Select
                  selectedOption={value}
                  onChange={({ detail }) => {
                    onChange(detail.selectedOption);
                  }}
                  onLoadItems={({ detail }) => { handleLoadItems(detail) }}
                  options={options}
                  statusType={status}
                  filteringType="manual"
                  filteringPlaceholder="Search query must be atleast 3 characters"
                  filteringAriaLabel="Filtering aria label"
                  loadingText="Loading aliases"
                  recoveryText="Retry"
                  errorText="Error fetching results."
                  placeholder="Alias"
                  onBlur={onBlur}
                  selectedAriaLabel="Selected"
                />
              )} />
          </FormField>
          <FormField
            description="This person would be assigned as the primary owner of the 3P product registered"
            label="Secondary owner's alias" errorText={props.errors?.secondary_owner_alias?.message?.toString()}>
            <Controller
              name="secondary_owner_alias"
              rules={{
                required: "Required field",
              }}
              control={props.control}
              defaultValue=""
              render={({ field: { onChange, value } }) => (
                <Select
                  selectedOption={value}
                  onChange={({ detail }) => {
                    onChange(detail.selectedOption);
                  }}
                  onLoadItems={({ detail }) => { handleLoadItems(detail) }}
                  options={options}
                  statusType={status}
                  filteringType="manual"
                  filteringPlaceholder="Search query must be atleast 3 characters"
                  filteringAriaLabel="Filtering aria label"
                  loadingText="Loading aliases"
                  recoveryText="Retry"
                  errorText="Error fetching results."
                  placeholder="Alias"
                  selectedAriaLabel="Selected"
                />
              )} />
          </FormField>
        </SpaceBetween>
        <FormField
          info={
            <Popover
              triggerType="text"
              dismissAriaLabel="Close"
              header="Bindles"
              content={<div>A Bindle is a team-owned collection of related resources for which permissions should be managed as a single entity. You can find your bindles at<br></br>
                <Link external
                  externalIconAriaLabel="Opens in a new tab"
                  href="https://bindles.amazon.com" variant="primary">
                  bindles.amazon.com
                </Link></div>}
            >
              <StatusIndicator type="info">Info</StatusIndicator>
            </Popover>
          }
          description="Enter the bindle ID you want to associate this record with"
          label="Bindle" errorText={props.errors?.bindle?.message?.toString()}>
          <Controller
            name="bindle"
            rules={{
              required: "Required field",
              maxLength: {
                value: 64,
                message: "Maximum accepted length is 64"
              },
              pattern: {
                value: /^.[\w.]+$/,
                message: "Only alphanumeric and period accepted"
              }
            }}
            control={props.control}
            defaultValue=""
            render={({ field: { onBlur, onChange, value } }) => (
              <Input placeholder="amzn1.bindle.resource.xxxxxxxxxx" value={value} onChange={({ detail }) => {
                onChange(detail.value);
              }}
                onBlur={onBlur} />
            )} />
        </FormField>
        <FormField
          info={
            <Popover
              triggerType="text"
              dismissAriaLabel="Close"
              header="PII"
              content={<div>Specific employee-related information falls into the category of Specific Human Resources Personally Identifiable Information (HR PII), for more information<br></br>
                <Link external
                  externalIconAriaLabel="Opens in a new tab"
                  href="https://w.amazon.com/bin/view/Main/Amazon_Information_Security/Policy/References/Specific_HR_PII/" variant="primary">
                  wiki
                </Link></div>}
            >
              <StatusIndicator type="info">Info</StatusIndicator>
            </Popover>
          }
          label="Does the system store, process, transmit any PII"
          description="PII is Personally Identifying Information">
          <Controller
            name="pii"
            rules={{ required: "Required field", }}
            control={props.control}
            defaultValue="yes"
            render={({ field: { onChange, value } }) => (
              <Tiles
                onChange={({ detail }) => { onChange(detail.value) }}
                value={value}
                items={[
                  { value: "yes", label: "Yes" },
                  { value: "no", label: "No" }
                ]}
              />
            )} />
        </FormField>
        <FormField
          info={
            <Popover
              triggerType="text"
              dismissAriaLabel="Close"
              header="PHI"
              content={<div>Employee health/medical information or history (such as Sick Day Records, Drug Screen data, Medical Leave data, National Patient ID, Disability status, Disability date, falls under Protected Health Information (PHI)<br></br>
              </div>}
            >
              <StatusIndicator type="info">Info</StatusIndicator>
            </Popover>
          }
          label="Does the system store, process, transmit any PHI"
          description="PHI is personal health information">
          <Controller
            name="phi"
            rules={{ required: "Required field", }}
            control={props.control}
            defaultValue="yes"
            render={({ field: { onChange, value } }) => (
              <Tiles
                onChange={({ detail }) => { onChange(detail.value) }}
                value={value}
                items={[
                  { value: "yes", label: "Yes" },
                  { value: "no", label: "No" }
                ]}
              />
            )} />
        </FormField>
      </SpaceBetween>
    </Container>
  );
}